import { useEffect, useState } from 'react'

import { Icon, Modal } from '@/shared'
import { EIcons } from '@App/types/iconType'
import {
    type ITransferServiceDto,
    type IChildServiceDec,
    type IServiceDec,
    type IServiceRulesWrapper
} from '@App/types/servicesTypes'
import { OTHERS_CATEGORY_ID } from '@Config/config'

import { ServiceInformation } from './ServiceInformation/ServiceInformation'
import { ServiceRules } from './ServiceRules/ServiceRules'
import { ServiceTransfer } from './ServiceTransfer/ServiceTransfer'
import style from './ServiceTransferModal.module.scss'
import { Tabs } from './Tabs/Tabs'

interface IProps {
    isFetching: boolean
    sections: IServiceDec[]
    tranferredService: IChildServiceDec
    serviceRules: IServiceRulesWrapper | null
    onGetServiceRules: (code: string) => void
    onSetServiceRules: (serviceRules: IServiceRulesWrapper | null) => void
    setTranferredService: (tranferredService: IChildServiceDec | null) => void
    onTransferService: (dto: ITransferServiceDto) => void
    onChangeRules: (dto: IServiceRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const ServiceTransferModal = (props: IProps) => {
    const {
        isFetching,
        sections,
        tranferredService,
        serviceRules,
        onGetServiceRules,
        setTranferredService,
        onTransferService,
        onChangeRules
        // onSetServiceRules
    } = props

    const tabs = ['Общая информация', 'Перенос услуги', 'Правила подготовки']

    const [currentTab, setCurrentTab] = useState(tabs[0])
    const [category, setCategory] = useState<IServiceDec | null>(null)
    const [chosen, setChosen] = useState<IServiceDec | null>(null)

    const header = `${tranferredService.name}`

    const onRemoveService = () => {
        if (tranferredService.parentId) {
            onTransferService({
                code: tranferredService.code,
                sourceId: tranferredService.parentId,
                destinationId: OTHERS_CATEGORY_ID
            })
        }
    }

    useEffect(() => {
        onGetServiceRules(tranferredService.code)
    }, [onGetServiceRules, tranferredService.code])

    return (
        <Modal show={!!tranferredService} onClose={() => setTranferredService(null)} modalStyles={style.modalStyles}>
            <div className={style.container}>
                <Tabs tabs={tabs} onSetTab={setCurrentTab} currentTab={currentTab} />
                <div className={style.header}>
                    <span>{header}</span>
                    <div className={style.removeIconWrapper} onClick={onRemoveService}>
                        <div>
                            <Icon iconName={EIcons.TRSH2} color='#007DEE' />
                        </div>
                    </div>
                </div>
                {currentTab === tabs[0] && <ServiceInformation tranferredService={tranferredService} />}
                {currentTab === tabs[1] && (
                    <ServiceTransfer
                        sections={sections}
                        tranferredService={tranferredService}
                        onTransferService={onTransferService}
                        chosen={chosen}
                        setChosen={setChosen}
                        category={category}
                        setCategory={setCategory}
                    />
                )}
                {currentTab === tabs[2] && (
                    <ServiceRules
                        isFetching={isFetching}
                        serviceRules={serviceRules}
                        onChangeRules={onChangeRules}
                        // onSetServiceRules={onSetServiceRules}
                    />
                )}
            </div>
        </Modal>
    )
}
